import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
import { jsx as _jsx } from "react/jsx-runtime";
export const RadioToggle = /*#__PURE__*/React.forwardRef(function RadioToggle(props) {
  const {
    className,
    style
  } = props;
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles['toggle'], className),
    style: style
  });
});